import React from "react";
import { useStoreActions, useStoreState } from "../store/hooks";

export function useApp() {
  const init = useStoreActions((actions) => actions.init);
  const connect = useStoreActions((actions) => actions.connect);
  const switchToPolygon = useStoreActions((actions) => actions.switchToPolygon);
  const mint = useStoreActions((actions) => actions.buy);
  const mintRef = useStoreActions((actions) => actions.mintRef);

  const status = useStoreState((state) => state.status);
  const mintedCount = useStoreState((state) => state.mintedCount);
  const tokenPrice = useStoreState((state) => state.tokenPrice);
  const wallet = useStoreState((state) => state.wallet);
  const errors = useStoreState((state) => state.errors);

  React.useEffect(() => {
    init();
  }, []);

  return {
    init,
    mintedCount,
    connect,
    switchToPolygon,
    status,
    tokenPrice,
    errors,
    mint,
    mintRef,
    wallet,
  };
}
